import { useContext } from 'react';

import { Context } from './context';
import { AssetsContext } from './types';

export function useAssets<T>(): AssetsContext<T> {
  return useContext(Context);
}
